<template>
  <BlocksLandingContainer :styles="styles">
    <section
      class="container-fluid-lg justify-center items-center relative flex flex-col gap-8"
    >
      <h2 class="self-stretch">
        {{ title }}
      </h2>
      <div class="relative max-w-full">
        <WebccScroll
          :buttons="screen.isSmall || 'hover'"
          @items-display="trackItemImpression"
        >
          <WebccLink
            v-for="{ link, image, index } in teasers"
            :key="index"
            :to="link.href"
            :target="link.target"
            anchor
            class="relative h-auto w-72 flex-shrink-0 flex-grow-0 cursor-pointer snap-start overflow-hidden rounded-lg border border-txt-weaker bg-bgr shadow"
            @click="trackItemClick(index)"
          >
            <figure class="w-full rounded-lg">
              <img
                loading="lazy"
                class="rounded-lg flex-shrink-0"
                :src="image.src"
                :alt="image.alt"
                :copyright="image.copyright"
              />
              <div
                v-if="link.alignment && link.text"
                class="absolute bg-bgr left-2 inline-flex justify-center items-center gap-2.5 p-2.5 rounded-lg"
                :class="ALIGNMENT_CLASSES[link.alignment]"
              >
                {{ link.text }}
              </div>
            </figure>
          </WebccLink>
        </WebccScroll>
      </div>
    </section>
  </BlocksLandingContainer>
</template>

<script setup lang="ts">
import { at } from 'lodash-es'

const ALIGNMENT_CLASSES = {
  top: 'top-2',
  bottom: 'bottom-2',
} as const

const props = defineProps<{
  block: Block<LandingTeaserBlockContent>
}>()

const tracking = useTracking()
const screen = useScreen()

const { title, styles, position } = toRefs(props.block.content)

const teasers = computed(() =>
  props.block.content.teasers.map(({ link, image }, index) => {
    return {
      index,
      image: { ...image, src: `${image.src}/tr:w-349,h-376` },
      link: {
        ...link,
        target: getLinkTarget(link),
        alignment: position.value || link.alignment,
      },
    }
  }),
)

function trackItemImpression(indexes: number[]) {
  tracking.handlers?.teaser.landingTeaserElementImpression(
    position.value,
    at(teasers.value, indexes),
  )
}

function trackItemClick(index: number) {
  tracking.handlers?.teaser.landingTeaserElementClick(
    position.value,
    teasers.value[index],
  )
}
</script>
